import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class WordReplacementService {
  private wordMap: { [key: string]: string } = {};

  setTermMap(mapFromApi: { [key: string]: string }) {
    this.wordMap = {};
    for (const key in mapFromApi) {
      if (mapFromApi.hasOwnProperty(key)) {
        this.wordMap[key.toLowerCase()] = mapFromApi[key];
      }
    }
  }

  replaceWord(original: string): string {
  const lowerOriginal = original.toLowerCase();

  // Check direct match
  let replacement = this.wordMap[lowerOriginal];

  // Check singular version if word is plural
  if (!replacement && lowerOriginal.endsWith('s')) {
    const singularForm = lowerOriginal.slice(0, -1);
    const singularReplacement = this.wordMap[singularForm];

    if (singularReplacement) {
      replacement = singularReplacement + 's';
    }
  }

  if (!replacement) return original;

  // Preserve original casing
  if (original === original.toUpperCase()) {
    return replacement.toUpperCase();
  } else if (original[0] === original[0].toUpperCase()) {
    return replacement[0].toUpperCase() + replacement.slice(1).toLowerCase();
  } else {
    return replacement.toLowerCase();
  }
}

  replaceWordsInSentence(input: string): string {
    if (!input) return '';
    return input.replace(/\b\w+\b/g, word => this.replaceWord(word));
  }
}
